module.exports = { raw: '9.5.1' };



//////////////////
// WEBPACK FOOTER
// ./node_modules/auth0-js/src/version.js
// module id = 47
// module chunks = 0